import React, { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import CancelSolutionButton from 'components/common/CancelSolutionButton';
import styles from './SolutionPublishEstimatePayment.module.scss';
import { NavLink } from 'react-router-dom';
import Popup from '../Popup/Popup';

const cx = classNames.bind(styles);

export default function SolutionPublishEstimatePayment({
  paymentType,
  onSubmit,
}) {
  const [active, setActive] = useState({
    once: false,
    rental: false,
  });

  useEffect(() => {
    if (paymentType === 'ONCE') {
      setActive({
        once: true,
        rental: false,
      });
    }

    if (paymentType === 'RENTAL') {
      setActive({
        once: false,
        rental: true,
      });
    }
  }, [paymentType, setActive]);

  const [buttonPopup, setButtonPopup] = useState(false);

  return (
    <div className={cx('container')}>
      <div className={cx('sub_container')}>
        <div className={cx('header_container')}>
          <div className={cx('inner')}>
            <div className={cx('header_inner')}>
              <div className={cx('selected_process_box')}>
                <div className={cx('process_title_box')}>
                  <h4 className={cx('selected_process_title')}>상품선택</h4>
                </div>
              </div>
              <div className={cx('selected_process_bar')}></div>
              <div className={cx('selected_process_box')}>
                <div className={cx('process_title_box')}>
                  <h4 className={cx('selected_process_title')}>견적요청</h4>
                </div>
              </div>
              <div className={cx('selected_process_bar')}></div>
              <div className={cx('selected_process_box')}>
                <div className={cx('selected_process_title_box')}>
                  <h4 className={cx('selected_process_title')}>견적검토</h4>
                </div>
              </div>
              <div className={cx('selected_process_bar')}></div>
              <div className={cx('selected_process_box')}>
                <div className={cx('selected_process_title_box')}>
                  <h4 className={cx('selected_process_title')}>설치확인</h4>
                </div>
              </div>
              <div className={cx('selected_process_bar')}></div>
              <div className={cx('selected_process_box')}>
                <div className={cx('selected_process_title_box')}>
                  <h4 className={cx('selected_process_title')}>유저정보</h4>
                </div>
              </div>
              <div className={cx('selected_process_bar')}></div>
              <div className={cx('select_process_box')}>
                <div className={cx('select_process_img_box')}>
                  <img
                    src="/statics/images/solution_select.png"
                    alt="solution_select"
                  />
                </div>
                <div className={cx('select_process_title_box')}>
                  <h4 className={cx('select_process_title')}>결제방식</h4>
                </div>
              </div>
              <div className={cx('select_process_bar')}></div>
              <div className={cx('process_status_box')}>
                <div className={cx('process_title_box')}>
                  <h4 className={cx('process_title')}>계약현황 확인</h4>
                </div>
              </div>
              <div className={cx('process_bar')}></div>
              <div className={cx('process_box')}>
                <div className={cx('process_title_box')}>
                  <h4 className={cx('process_title')}>계약서 작성</h4>
                </div>
              </div>
              <div className={cx('process_bar')}></div>
              <div className={cx('process_box')}>
                <div className={cx('process_title_box')}>
                  <h4 className={cx('process_title')}>입금 확인</h4>
                </div>
              </div>
              <div className={cx('process_bar')}></div>
              <div className={cx('process_box')}>
                <div className={cx('process_title_box')}>
                  <h4 className={cx('process_title')}>설치 스케줄</h4>
                </div>
              </div>
            </div>
            <div className={cx('mobile_header_inner')}>
              <div className={cx('mobile_header_progressbar_box')}>
                <div className={cx('mobile_header_progressbar')}></div>
              </div>
              <div className={cx('select_process_box')}>
                <div className={cx('mobile_select_text_box')}>
                  <p className={cx('mobile_select_text')}>step.6</p>
                </div>
                <div className={cx('mobile_select_process_title_box')}>
                  <div className={cx('select_process_title_box')}>
                    <h4 className={cx('select_process_title')}>결제방식</h4>
                  </div>
                  <div className={cx('select_process_img_box')}>
                    <img
                      src="/statics/images/solution_select.png"
                      alt="solution_select"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={cx('inner')}>
          <div className={cx('inner_box')}>
            <CancelSolutionButton />
            <div
              className={cx('checklist_button')}
              onClick={() => setButtonPopup(true)}
            >
              <div className={cx('checklist_icon_box')}>
                <img
                  className={cx('checklist_icon')}
                  src="/statics/images/check_list.png"
                  alt="check_list"
                />
              </div>
              <div className={cx('hide_text_box')}>
                <p className={cx('hide_text')}>체크리스트 보기</p>
              </div>
            </div>
            <div className={cx('title_box')}>
              <h4 className={cx('title')}>결제방식 선택</h4>
            </div>
            <div className={cx('content_inner')}>
              <div
                onClick={() =>
                  setActive((prev) => ({
                    ...prev,
                    once: !prev.once,
                    rental: false,
                  }))
                }
                className={cx(active.once ? 'active_select_box' : 'select_box')}
              >
                <div className={cx('select_title_box')}>
                  <h4 className={cx('select_title')}>일시불 결제</h4>
                </div>
                <div className={cx('select_text_box')}>
                  <p className={cx('select_text')}>현금 계좌 이체</p>
                </div>
                <div className={cx('select_sub_text_box')}>
                  <p className={cx('select_sub_text')}>
                    *선택 시, 계약현황 확인 단계는 생략됩니다.
                  </p>
                </div>
              </div>
              <div
                onClick={() =>
                  setActive((prev) => ({
                    ...prev,
                    rental: !prev.rental,
                    once: false,
                  }))
                }
                className={cx(
                  active.rental ? 'active_select_box' : 'select_box',
                )}
              >
                <div className={cx('select_title_box')}>
                  <h4 className={cx('select_title')}>할부 결제</h4>
                </div>
                <div className={cx('select_text_box')}>
                  <p className={cx('select_text')}>렌탈 할부 결제</p>
                </div>
                <div className={cx('select_sub_text_box')}>
                  <p className={cx('select_sub_text')}>
                    *자세한 정보는 계약현황 확인 단계에서 안내드립니다.
                  </p>
                </div>
              </div>
            </div>
            <div className={cx('button_box')}>
              {/* <div className={cx('prev_button_box')}>
                <NavLink
                  to="/solution/publish-estimate/success"
                  className={cx('prev_button')}
                >
                  이전 단계 확인
                </NavLink>
              </div> */}
              <div className={cx('next_button_box')}>
                <button
                  className={cx('next_button')}
                  onClick={() => onSubmit(active)}
                >
                  다음 단계로 이동
                </button>
              </div>
            </div>
            <Popup trigger={buttonPopup} setTrigger={setButtonPopup} />
          </div>
        </div>
      </div>
    </div>
  );
}
